import '../fonts/DMSans/DMSans-VariableFont_opsz,wght.ttf'
import '../fonts/DMSans/DMSans-Italic-VariableFont_opsz,wght.ttf'

import type { FC } from 'react'
import { lazy, Suspense } from 'react'
import { Provider } from 'react-redux'
import { Slide, ToastContainer } from 'react-toastify'
import { IconX } from '@tabler/icons-react'

import { store } from '@/stores/redux/store'

import AppPreloader from './app-preloader'

import 'react-toastify/dist/ReactToastify.css'
import '@/styles/v1/tailwind.css'
import '@/styles/globals.scss'
import '@/styles/toast.scss'

const AppRouter = lazy(() => import('./app-router'))

const App: FC = () => {
  return (
    <Provider store={store}>
      <Suspense fallback={<AppPreloader />}>
        <AppRouter />
      </Suspense>
      <ToastContainer
        position='bottom-right'
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
        theme='colored'
        transition={Slide}
        closeButton={<IconX width={18} height={18} />}
      />
    </Provider>
  )
}

export default App
